/**
 * Header Title placeholder element id
 */
export const HEADER_TITLE = 'header-title';
